import React from 'react';
import { Hyperlink } from '@fx-ui/jdy-design-biz';
import classNames from 'classnames';
import { isMobileUA } from '~/utils';

interface IFootConfigProps {
    width?: string;
}

/**
 * 登录/注册页底部的ICP备案信息（只有dev环境有）
 *
 * @param props
 * @constructor
 */
const Footer: React.FunctionComponent<IFootConfigProps> = (props) => {
    const { width } = props;
    const {
        icp = '',
        icp_link = '',
        gongan,
        gongan_link,
        gongan_icon,
        copyright
    } = window.jdy_foot_config || {};

    if (!icp) {
        return null;
    }

    return (
        <div
            className={classNames('fx-company-footer', {
                'is-mobile': isMobileUA()
            })}
            style={{ width: width }}
        >
            <Hyperlink underline={false} className="hyperlink" href={icp_link}>
                {icp}
            </Hyperlink>
            {gongan ? (
                <Hyperlink underline={false} className="hyperlink" href={gongan_link}>
                    <img src={gongan_icon} alt="" />
                    <span>{gongan}</span>
                </Hyperlink>
            ) : null}
            {copyright ? <span className="company-name">{copyright}</span> : null}
        </div>
    );
};

export default Footer;
